// Lib
import { clamp } from 'lodash/fp';

// Constants
import { RECT_EDGES } from '../../../../../common/maths/geometry/rect/rectConstants';

/**
 * Finds the center value of an edge.
 */
export const getTrueEdgeCenter = (edge, rect) => {
    switch (edge) {
        case RECT_EDGES.left:
        case RECT_EDGES.right:
            return (rect.bottom + rect.top) / 2;
        default:
            return (rect.left + rect.right) / 2;
    }
};

const getClampedEdgeValue = (edge, layerRect, value) => {
    switch (edge) {
        case RECT_EDGES.left:
        case RECT_EDGES.right:
            return clamp(layerRect.top, layerRect.bottom, value);
        default:
            return clamp(layerRect.left, layerRect.right, value);
    }
};

export default ({ targetRect, layerRect, edge }) => {
    const trueCenter = getTrueEdgeCenter(edge, targetRect);
    return getClampedEdgeValue(edge, layerRect, trueCenter);
};
